// import React from "react";
// import "../../css/leads/leadfilters.css";

// export default function LeadFilters({ filters, setFilters }) {
//   return (
//     <div className="lead-filters">
//       {/* Status Filter */}
//       <select
//         className="filter-select"
//         value={filters.status}
//         onChange={(e) =>
//           setFilters({ ...filters, status: e.target.value })
//         }
//       >
//         <option value="all">All Status</option>
//         <option value="new">New</option>
//         <option value="contacted">Contacted</option>
//         <option value="qualified">Qualified</option>
//         <option value="viewing_scheduled">Viewing Scheduled</option>
//         <option value="negotiating">Negotiating</option>
//       </select>

//       {/* Lead Type Filter */}
//       <select
//         className="filter-select"
//         value={filters.lead_type}
//         onChange={(e) =>
//           setFilters({ ...filters, lead_type: e.target.value })
//         }
//       >
//         <option value="all">All Types</option>
//         <option value="buyer">Buyer</option>
//         <option value="seller">Seller</option>
//         <option value="renter">Renter</option>
//       </select>

//       {/* Source Filter */}
//       <select
//         className="filter-select"
//         value={filters.source}
//         onChange={(e) =>
//           setFilters({ ...filters, source: e.target.value })
//         }
//       >
//         <option value="all">All Sources</option>
//         <option value="website">Website</option>
//         <option value="zillow">99 Acres</option>
//         <option value="referral">Referral</option>
//         <option value="facebook">Facebook</option>
//       </select>
//     </div>
//   );
// }

// Updated: 23-05-2026
// Changes:
// - Fixed source filter: values now match LeadForm SOURCE_OPTIONS exactly
// - Added interest_level filter: Hot / Warm / Cold

import React from "react";
import "../../css/leads/leadfilters.css";

export default function LeadFilters({ filters, setFilters }) {
  const update = (key, val) =>
    setFilters((prev) => ({ ...prev, [key]: val }));

  return (
    <div className="lead-filters">

      {/* Status Filter */}
      <select
        className="filter-select"
        value={filters.status}
        onChange={(e) => update("status", e.target.value)}
      >
        <option value="all">All Status</option>
        <option value="new">New</option>
        <option value="contacted">Contacted</option>
        <option value="interested">Interested</option>
        <option value="follow_up">Follow-up</option>
        <option value="matured">Matured</option>
        <option value="closed">Closed</option>
        <option value="lost">Lost</option>
      </select>

      {/* Lead Type Filter */}
      <select
        className="filter-select"
        value={filters.lead_type}
        onChange={(e) => update("lead_type", e.target.value)}
      >
        <option value="all">All Types</option>
        <option value="buyer">Buyer</option>
        <option value="renter">Tenant</option>
      </select>

      {/* Source Filter — values match LeadForm SOURCE_OPTIONS */}
      <select
        className="filter-select"
        value={filters.source}
        onChange={(e) => update("source", e.target.value)}
      >
        <option value="all">All Sources</option>
        <option value="website">Website</option>
        <option value="facebook">Social Media</option>
        <option value="google">Google</option>
        <option value="walkin">Walk-in</option>
        <option value="referral">Referral</option>
        <option value="whatsapp">WhatsApp</option>
        <option value="other">Other</option>
      </select>

      {/* Interest Level Filter — NEW */}
      <select
        className="filter-select"
        value={filters.interest_level}
        onChange={(e) => update("interest_level", e.target.value)}
      >
        <option value="all">All Categories</option>
        <option value="hot">🔥 Hot</option>
        <option value="warm">🌤 Warm</option>
        <option value="cold">❄️ Cold</option>
      </select>

    </div>
  );
}